export const monitoring = {
    "activeMonitoring": {
        "pageTitle": "Keep track on tenants monitoring",
        "tabs": {
            "inMonitoring": "Apts in monitoring",
            "withoutMonitoring": "Apts without monitoring"
        },
        "totalTenants": "Total num of tenants:",
        "labels": {
            "tenantValue": "Tenant value",
            "actionName": "Action name",
            "nextActionIn": "Next action in",
            "nextActionName": "Next action name",
            "sentAt": "Sent at",
            "totalAmountMissing": "Total amount missing",
            "days": "days",
            "hours": "hours",
            "tenantEmail": "Tenant Email",
            "tenantPhone": "Tenant Phone",
            "ownerEmail": "Owner Email",
            "ownerPhone": "Owner Phone",
        },
        "actions": {
            "welcome": "Welcome",
            "reminder": "Payment Reminder",
            "tenantEmail1": "1st tenant email message",
            "tenantEmail2": "2st tenant email message",
            "tenantEmail3": "3st tenant email message",
            "tenantEmail4": "4st tenant email message",
            "tenantPhone1": "1st tenant SMS",
            "tenantPhone2": "2nd tenant SMS",
            "tenantPhone3": "3rd tenant SMS",
            "tenantPhone4": "4th tenant SMS",
            "ownerEmail1": "1st owner email message",
            "ownerEmail2": "2st owner email message",
            "ownerEmail3": "3st owner email message",
            "ownerEmail4": "4st owner email message",
            "ownerPhone1": "1st owner SMS",
            "ownerPhone2": "2nd owner SMS",
            "ownerPhone3": "3rd owner SMS",
            "ownerPhone4": "4th owner SMS",
        },
        "btns": {
            "stopMonitoring": "Stop monitoring",
            "stopMonitoringApartment": "stop monitoring apartment",
            "startMonitoring": "Start monitoring",
            "startMonitoringApartment": "Start monitoring apartment",
            "aptNotes": "Apt notes",
            "startAll": "Start all",
            "stopAll": "Stop all",
        },
        "successfullyStarted": "The apartment monitoring was successfully started",
        "successfullyStopped": "The apartment monitoring was successfully stopped",
        "successfullyAllStarted": "All apartments monitoring was successfully started",
        "successfullyAllStopped": "All apartments monitoring was successfully stopped",
        "somethingWentWrong": "Something went wrong",
    }
}
